import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import ProductSlider from './Helpers/ProductSlider';
import { getCollectionList } from '../../../actions/kafairAction';
import { Container } from 'reactstrap';
import ArrowHPPrev from '../../../images/arrow-hp-prev.png';
import ArrowHPNext from '../../../images/arrow-hp-next.png';
import emptySneakerImg from '../../../images/emptysneakers2.png';
import emptyApparelImg from '../../../images/emptyapparels.png';
import emptyHandbagImg from '../../../images/emptyhandbags.png';
import emptyLifestyles from '../../../images/emptylifestyles.png';
import ArrowBlackRight from '../../../images/arrow-black-right.png';
import ArrowBlackLeft from '../../../images/arrow-black-left.png';
import Slider from 'react-slick';
import HotProduct from '../../../images/fire-product.png';
import ReactLoading from 'react-loading';
import { TextRupiah } from '../../Text';
import {
  convertBrandNameToSlug,
  getCloudImageUrl,
  emptyImage,
} from '../../../utils/Helpers';
import styled from 'styled-components';
import {
  editorsChoicePage,
  getTopSellingProduct,
  sortingSearchResultAPI,
} from '../../../actions/productAction';
import { Link } from 'react-router-dom';
interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

const PrevSlideHP = (props: PreviousSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      left: 20px !important;
      position: absolute;
      object-fit: contain;
    }
    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        left: '40px !important',
        width: '40px',
        height: '40px',
        display: window.screen.availWidth < 640 ? 'none' : 'block',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackLeft : ArrowHPPrev} alt="..." />
    </LeftArrow>
  );
};

const NextSlideHP = (props: NextSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      right: -80px;
      position: absolute;
    }
    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        display: window.screen.availWidth < 640 && 'none',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackRight : ArrowHPNext} alt="..." />
    </LeftArrow>
  );
};

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: <PrevSlideHP />,
  nextArrow: <NextSlideHP />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

type HotProducts = {
  getCollectionList: (
    category: string,
    slug: string,
    payload: object,
    name: string,
  ) => any;
  dataProducts: Array<Object>;
  category: string;
  history: History;
  getProducts: (category: string, payload: Object) => any;
  dataCategory: string;
  getTrendingProduct: (payload: Object, category: string) => any;
  dataTrending: Array<Object>;
  sortingSearchResult: (category: string, payload: Object, type: string) => any;
  dataTopSelling: Array<Object>;
  getTopSellingProduct: () => any;
  sortingSearchResultAPI: () => any;
};

const HotProducts: FC<HotProducts> = ({
  dataProducts,
  category,
  history,
  getProducts,
  getTopSellingProduct,
  sortingSearchResultAPI,
  getCollectionList,
}) => {
  const [selectedCategory, setSelectedCategory] = useState(1);
  const [categorySection, setCategorySection] = useState([
    {
      id: 1,
      title: 'Hot Products',
      value: 'editors-choices',
      slug: 'hot-products',
    },
    {
      id: 2,
      title: 'Most Popular',
      value: 'most-popular',
      slug: 'most-popular',
    },
    {
      id: 3,
      title: 'Best Selling',
      value: 'trending-now',
      slug: 'best-selling',
    },
  ]);
  const [selectedOption, setSelectedOption] = useState('Hot Products');
  const [optionSlug, setOptionSlug] = useState('hot-products');
  const [dataSlider, setDataSlider] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryUrl, setCategoryUrl] = useState('');

  useEffect(() => {
    // Display hot products collection based on current category
    changeSelectedSection(selectedCategory);
  }, []);

  useEffect(() => {
    // Set API condition based on current category
    let categoryUrl =
      category === 'apparels' || category === 'Apparels'
        ? 'apparel'
        : category === 'handbags'
        ? 'luxury'
        : category === 'lifestyles'
        ? 'electronics-collectibles'
        : category;
    setCategoryUrl(categoryUrl);
  }, [category]);

  useEffect(() => {
    // Set data slider based on current products
    if (dataProducts.length > 0) {
      setDataSlider(dataProducts);
    }
  }, [dataProducts]);

  interface CategorySectionItem {
    id: number;
  }

  async function changeSelectedSection(id: number) {
    setSelectedCategory(id);
    setIsLoading(true);

    // Function to display products based on current selected option

    let paramSection =
      categorySection &&
      categorySection.find((item: CategorySectionItem) => item.id == id).value;
    let nameSection =
      categorySection &&
      categorySection.find((item: CategorySectionItem) => item.id == id).title;
    let slugSection =
      categorySection &&
      categorySection.find((item: CategorySectionItem) => item.id == id).slug;

    await setSelectedOption(nameSection);

    await setOptionSlug(slugSection);

    if (paramSection === 'editors-choices') {
      // If option hot products is chosen
      await getProducts(paramSection, {
        params: {
          page: 1,
          availables: true,
          category: category,
          per_page: 11,
        },
      });
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    } else if (paramSection === 'most-popular') {
      // If option most popular is selected
      await sortingSearchResultAPI('', {
        params: {
          category: category,
          sort_by: 'most_popular',
          page: 1,
          availables: true,
          per_page: 11,
        },
      });
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    } else {
      // If option best selling is selected
      const payload = {
        params: {
          category: category,
          per_page: 11,
          page: 1,
          range_value: 50,
          availables: true,
          range_type: 'week',
          range_value: 1,
        },
      };
      getTopSellingProduct(payload)
        .then(({ value }) => {
          return setDataSlider(value.data.data);
        })
        .catch((e) => null);

      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  }

  interface LeftHeaderItem {
    id: number;
    title: string;
  }

  if (window.screen.availWidth < 480) {
    return (
      <Container fluid id={'HotProducts__V3-mobile'}>
        <div className="HotProducts__Header">
          <div className="HotProducts__Left-mobile">
            {categorySection &&
              categorySection.map((item: LeftHeaderItem) => {
                return (
                  <div
                    className={`category-section__${item.id}`}
                    key={item.id}
                    onClick={() => changeSelectedSection(item.id)}
                  >
                    <p
                      className={`${item.id == selectedCategory && 'selected'}`}
                      style={{
                        opacity: item.id === selectedCategory ? '1' : '0.8',
                      }}
                    >
                      {item.title}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        <div style={{ height: '304px', position: 'relative' }}>
          {isLoading && (
            <div
              style={{
                width: 'fit-content',
                height: '100%',
                position: 'absolute',
                inset: '32.5% 41%',
              }}
            >
              <ReactLoading
                type={'spin'}
                height={50}
                width={50}
                color={'#fff'}
              />
            </div>
          )}
          {!isLoading && dataSlider && dataSlider.length > 0 ? (
            <ProductSlider
              dataProducts={dataSlider}
              isHotProducts
              chosenOption={selectedOption}
              activeBrowseAll
              navigateUrl={`/${categoryUrl}/${optionSlug}`}
            />
          ) : !isLoading && dataSlider.length <= 0 ? (
            <div className="no-products">
              <p>No products available</p>
            </div>
          ) : null}
        </div>
      </Container>
    );
  }

  interface URL {
    URL: string;
  }

  interface Name {
    name: string;
  }
  interface Category {
    category: Name;
  }

  interface ItemSlider {
    slug: string;
    id: number;
    editors_choice: boolean;
    product_variant_images: Array<URL>;
    display_name: string;
    product: Category;
    price: string;
    vintage: boolean;
    brand: string;
  }

  const onClickItem = (url) => history.push(url);

  return (
    <Container fluid id="Hot-Products__V3">
      <div className="Hot-Products__Header">
        <div className="Hot-Products__LeftHeader">
          {categorySection &&
            categorySection.map((item: LeftHeaderItem) => (
              <div onClick={() => changeSelectedSection(item.id)} key={item.id}>
                <p className={`${item.id == selectedCategory && 'selected'}`}>
                  {item.title}
                </p>
              </div>
            ))}
        </div>
      </div>
      <div
        style={{
          width: '95%',
          marginLeft: 'auto',
          marginRight: 'auto',
          height: '305px',
          position: 'relative',
        }}
        className="Hot-Products__Main"
      >
        {isLoading && (
          <div
            style={{
              width: 'fit-content',
              height: '100%',
              position: 'absolute',
              inset: '40% 47.5%',
              translate: 'transform(-47.5%, -47.5%)',
            }}
          >
            <ReactLoading type={'spin'} height={50} width={50} color={'#fff'} />
          </div>
        )}
        {!isLoading &&
          dataSlider &&
          dataSlider.length > 0 &&
          dataSlider.length <= 4 && (
            <ProductSlider
              dataProducts={dataSlider}
              isHotProducts
              chosenOption={selectedOption}
              activeBrowseAll
              navigateUrl={`/${categoryUrl}/${optionSlug}`}
            />
          )}
        {!isLoading &&
        dataSlider &&
        dataSlider.length > 0 &&
        dataSlider.length > 4 ? (
          <Slider {...settings}>
            {dataSlider.map((item: ItemSlider) => {
              const brand = item && item.product && item.product.brand;
              const brandSlug = brand?.flat?.[0]
                ? convertBrandNameToSlug(brand?.flat?.[0])
                : brand?.slug;
              const categoryName =
                item &&
                item.product &&
                item.product.category &&
                item.product.category.name;
              const isOnlyKickPoint =
                item?.variant_payment_methods?.length === 1 &&
                !!item?.variant_payment_methods?.find(
                  (item) =>
                    item?.payment_method === 'kick_point' ||
                    item === 'kick_point',
                );

              return (
                <Link
                  key={item.id}
                  to={`${categoryUrl}/${brandSlug}/${item.slug}${
                    item.vintage ? `?vintage=true&from=home` : '?from=home'
                  }`}
                  className="homepage-product__section"
                >
                  <div
                    style={{ position: item.editors_choice && 'relative' }}
                    className="homepage-product__container"
                  >
                    {item.editors_choice && (
                      <KickImage
                        className="isHotProduct"
                        src={HotProduct}
                        alt="hot product"
                      />
                    )}
                    <KickImage
                      className="homepage-product__img"
                      src={
                        item.product_variant_images.length > 0 &&
                        item.product_variant_images[0].URL.indexOf(
                          's3.amazonaws.com',
                        ) > 0
                          ? getCloudImageUrl(
                              item.product_variant_images[0].URL,
                              500,
                            )
                          : emptyImage(item.product.category)
                      }
                      alt=""
                    />
                    {categoryName === 'handbags' ||
                    item.category === 'handbags' ? (
                      <p className="homepage-product__brand">
                        {brand?.flat?.length > 0 ? brand?.flat[0] : brand?.name}
                      </p>
                    ) : null}
                    <p className="homepage-product__name">
                      {item.display_name}
                    </p>
                    <p
                      style={{ color: '#159953' }}
                      className="homepage-product__price"
                    >
                      {item.latest_price && item.latest_price.asking_price ? (
                        <TextRupiah
                          prefix="IDR. "
                          color="#159953"
                          align="right"
                          value={
                            item.latest_price &&
                            item.latest_price.asking_price.toString()
                          }
                          isOnlyKickPoint={isOnlyKickPoint}
                        />
                      ) : (
                        <span style={{ color: '#dc3545' }}>Out of Stock</span>
                      )}
                    </p>
                  </div>
                </Link>
              );
            })}
            {dataSlider && (
              <a
                target="_blank"
                href={`/${categoryUrl}/${optionSlug}`}
                className="homepage-lastSlide"
              >
                <div
                  style={{ border: '1px solid #fff' }}
                  className="homepage-showAll"
                  onClick={() => {
                    localStorage.removeItem('collectionSortedBy');
                  }}
                >
                  <h4 style={{ color: '#fff' }}>View All</h4>
                  <p style={{ color: '#fff' }}>{selectedOption}</p>
                </div>
              </a>
            )}
          </Slider>
        ) : !isLoading && dataSlider.length <= 0 ? (
          <div className="no-products">
            <p>No products available</p>
          </div>
        ) : null}
      </div>
    </Container>
  );
};

interface Selected {
  selected: string;
}

interface Data {
  data: Array<Object>;
}
interface SearchResult {
  searchResult: Array<Object>;
  topSelling: Data;
}
interface State {
  dataProduct: SearchResult;
  dataAuth: any;
}

const mapStateToProps = (state: State) => ({
  dataProducts: state.dataProduct.searchResult,
  dataTopSelling: state.dataProduct.topSelling.data,
});

const mapDispatchToProps = (dispatch: any) => ({
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => dispatch(getCollectionList(category, slug, payload, name)),
  getProducts: (category: string, params: Object) =>
    dispatch(editorsChoicePage(category, params)),
  getTopSellingProduct: (payload: Object, category: string) =>
    dispatch(getTopSellingProduct(payload, category)),
  sortingSearchResultAPI: (
    paramsRoute: Object,
    caseSort: string,
    status_action: any,
  ) => dispatch(sortingSearchResultAPI(paramsRoute, caseSort, status_action)),
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => dispatch(getCollectionList(category, slug, payload, name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HotProducts);
